module.exports = __webpack_public_path__ + "static/media/dep2.786ead02.jpg";